module.exports = __webpack_public_path__ + "r-v3/img/neon-pen_off.584e3d54.svg";